import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { WhichWeightAPI } from 'WhichWeightAPI'

import ContentFrame from 'components/Frame/ContentFrame'
import WorkoutListItem from 'components/Workout/WorkoutListItem'

export default function WorkoutsTab() {

    const profileType = useSelector(state => state.athleteProfile.profileType)
    const groupId = useSelector(state => state.athleteProfile.groupId)
    const athleteId = useSelector(state => state.athleteProfile.userId)

    const [workouts, setWorkouts] = useState(null)

    const FetchWorkoutsFromBackend = async () => {

        if (profileType === 'group') {
            const jsonBody = {
                groupId: groupId
            }

            // console.log(jsonBody);

            const result = await WhichWeightAPI('REPORTING', 'GET', '/group_completed_workouts', jsonBody)

            // console.log(result);

            if (result.data.status === 'failure') {
                console.error(result.data)
                setWorkouts([])
                return
            }
            
            setWorkouts(result.data.data)
        }

        if (profileType === 'group-individual' || profileType === 'individual') {
            const jsonBody = {
                userId: athleteId
            }

            // console.log(jsonBody);

            const result = await WhichWeightAPI('REPORTING', 'GET', '/athlete_completed_workouts', jsonBody)

            // console.log(result.data.data);

            if (result.data.status === 'failure') {
                console.error(result.data)
                setWorkouts([])
                return
            }

            setWorkouts(result.data.data)
        }

    }

    useEffect(() => { FetchWorkoutsFromBackend() }, [])

    if (workouts === null) {
        return (
            <div className='space-y-4'>
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
                <div className='w-full h-20 bg-gray-200 rounded-lg animate-pulse' />
            </div>
        )
    }

    return (
        <>
            <ContentFrame className='divide-y divide-gray-200'>
                {workouts.length === 0 &&
                    <div className="text-center text-gray-500 py-4">No workouts found</div>
                }

                {workouts.length > 0 && workouts.map((workout, index) => (
                    <WorkoutListItem key={index} workout={workout} />
                ))}
            </ContentFrame>
        </>
    )
}
